export const maxRowBasedquery = '(min-width: 600px)'